/* eslint-disable react/prop-types */
import React from "react";
import "./styles.scss";

const MoreOptionsDropdownButton = React.forwardRef(
  ({ children, onClick, variant }, ref) => {
    return (
      <div
        ref={ref}
        className={
          variant === "vertical"
            ? "ps-more-options-button--vertical"
            : "ps-more-options-button"
        }
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </div>
    );
  }
);

MoreOptionsDropdownButton.displayName = "MoreOptionsDropdownButton";

export default MoreOptionsDropdownButton;
